export const scrollToId = (id: string) => {
  const element = document.querySelector(String(id));
  element &&
    element.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth'
    });
};
